import * as JWT from '@breathelife/jwt';

export function validateTokenNonce(token: string, nonce: string): void {
  if (!JWT.isTokenNonceValid(token, nonce)) {
    // Prevent replay attack https://auth0.com/docs/api-auth/tutorials/nonce
    throw new Error('Potential replay attack, invalid token');
  }
}
